import { CityOutputCityData } from './city-output-city-data.model';


export class StateWithCityOutputStateData implements IStateWithCityOutputStateData {
    /** The auto-generated id of the state master */
    state_id!: number;
    /** The state name with 255 character limit */
    state_name!: string;
    /** Manage status of state. 0 For De-active, 1 For Active */
    status!: number;
    city!: CityOutputCityData[];

    constructor(data?: IStateWithCityOutputStateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state_id = _data["state_id"];
            this.state_name = _data["state_name"];
            this.status = _data["status"];
            if (Array.isArray(_data["city"])) {
                this.city = [] as any;
                for (let item of _data["city"])
                    this.city!.push(CityOutputCityData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StateWithCityOutputStateData {
        data = typeof data === 'object' ? data : {};
        let result = new StateWithCityOutputStateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state_id"] = this.state_id;
        data["state_name"] = this.state_name;
        data["status"] = this.status;
        if (Array.isArray(this.city)) {
            data["city"] = [];
            for (let item of this.city)
                data["city"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStateWithCityOutputStateData {
    /** The auto-generated id of the state master */
    state_id: number;
    /** The state name with 255 character limit */
    state_name: string;
    /** Manage status of state. 0 For De-active, 1 For Active */
    status: number;
    city: CityOutputCityData[];
}

